import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { getSDM17DECs } from '../../data/SDM17DEC/actions';

class SDM17DEC extends PureComponent {
    static propTypes = {
        initialized: PropTypes.bool.isRequired,
        getSDM17DECs: PropTypes.func.isRequired,
        SDM17DECs: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshSDM17DECs();
    }

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `SDM17DEC/detail/${rowData.id}` });
    };

    /* ACTIONS */
    refreshSDM17DECs = () => {
        const { getSDM17DECs } = this.props;
        this.setState({ loading: true });
        return getSDM17DECs()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRight = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`general.products.SDM17DEC.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshSDM17DECs
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('SDM17DECDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(SDM17DECs => {
        let result = [];
        SDM17DECs.map(SDM17DEC => {
            result.push({
                id: SDM17DEC.get('macAddress'),
                macAddress: SDM17DEC.get('macAddress')
                    .match(/.{1,2}/g)
                    .join(':'),
                addressIp: SDM17DEC.get('addressIp'),
                email: SDM17DEC.get('userEmail'),
                label: SDM17DEC.get('label'),
                state: SDM17DEC.getIn(['state'], false) ? Translator.translate(`general.${SDM17DEC.get('state')}`) : null,
                firmwareVersion: SDM17DEC.get('firmwareVersion'),
                usersList: SDM17DEC.get('usersList'),
                userMasterId: SDM17DEC.get('userMasterId')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { classes, history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('SDM17DECDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'addressIp'
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            }
        ];
    });
    render() {
        const { loading } = this.state;
        const { profile, SDM17DECs, history } = this.props;

        return (
            <FHETable
                idTable="SDM17DECList"
                columns={this.renderColumns(profile)}
                data={this.renderData(SDM17DECs)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`general.products.SDM17DEC.table.title`)}
                emptyDataSourceMessage={Translator.translate(`general.products.SDM17DEC.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const users = state.environments[history.environment].data.Users.get('list');
    let SDM17DECs = state.environments[history.environment].data.SDM17DEC.get('list');
    SDM17DECs = SDM17DECs.map(SDM17DEC => {
        const masterId = SDM17DEC.getIn(['userMasterId'], '');
        return SDM17DEC.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], ''));
    });

    return {
        profile: state.data.user,
        SDM17DECs,
        initialized: state.environments[history.environment].data.SDM17DEC.get('initialized')
    };
}
const styles = theme => ({
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getSDM17DECs }, dispatch)
    )(withStyles(styles, { withTheme: true })(SDM17DEC))
);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/index.js